export const ADD_NEW_QUIZ = "ADD_NEW_QUIZ";
export const REMOVE_QUIZ = "REMOVE_QUIZ";
